import $ from "jquery";

const research = (scroll) => {
    $('#hero__btn').click(function() {
        scroll.update();
        $('#hero__btn').toggleClass('active');
        $('.hero__text-hidden').slideToggle();
    })
    
};

export default research;
